export default __webpack_public_path__ + "static/media/updatedLogo.729be211.svg";